import React from 'react';
import { useUser } from '@/contexts/UserContext';
import { colors } from '@/design-system/colors';

const ROLE_LABEL: Record<string, string> = { admin: 'Admin', member: 'Member', client: 'Client', vendor: 'Vendor' };

/**
 * Sidebar / mobile drawer: which of the person's companies they are working in. Renders nothing for the (usual) case of a single company, so the
 * navigation of everyone else is unchanged. Each company shows the role the person holds THERE -- the same person can be a Vendor in one and an Admin in
 * another. Choosing one reloads the app on that company (the server re-checks the choice on every request).
 */
export function CompanySwitcher() {
  const { companies, companyId, switchCompany } = useUser();
  if (companies.length < 2 || !companyId) return null;

  return (
    <div className="px-1 pb-1" data-testid="company-switcher">
      <label htmlFor="company-switcher-select" className="sr-only">Company</label>
      <select
        id="company-switcher-select"
        value={companyId}
        onChange={(event) => switchCompany(event.target.value)}
        className="w-full rounded-lg px-3 py-2 nav-subheader"
        style={{ backgroundColor: colors.sidebarActive, color: colors.sidebarText }}
      >
        {companies.map((company) => (
          <option key={company.company_id} value={company.company_id}>
            {company.name} ({ROLE_LABEL[company.role] || company.role})
          </option>
        ))}
      </select>
    </div>
  );
}

export default CompanySwitcher;
